module.exports = __webpack_public_path__ + "img/landing_box37.347c1a3f.jpg";